// import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import App from './App.vue'
import router from './router'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import vuetify from '@/plugins/vuetify'

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import LoadScript from 'vue-plugin-load-script'
import { CONFIG } from '@/config'

const app = createApp(App)
app.component('VueDatePicker', VueDatePicker)

Sentry.init({
  app,
  dsn: `${CONFIG.SENTRY_DSN}`,
  environment: `${CONFIG.RUNNING_IN_ENV}`,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/poker-admin.oneteam.ca\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
// pinia.use(resetStore)

app.use(pinia)
app.use(vuetify)
app.use(router)
app.use(LoadScript)

app.mount('#app')

//
// // import './assets/main.css'
//
// import { createApp } from 'vue'
// import { createPinia } from 'pinia'
//
// import App from './App.vue'
// import router from '@/router'
//
// import resetStore from '@/plugins/resetStore'
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
//
// import vuetify from '@/plugins/vuetify'
//
// // import * as Sentry from "@sentry/vue";
// // import * as Integrations from "@sentry/integrations";
//
// // https://vue3datepicker.com/props/modes/#timezone
// import VueDatePicker from '@vuepic/vue-datepicker'
// import '@vuepic/vue-datepicker/dist/main.css'
// import LoadScript from 'vue-plugin-load-script'
//
// // const vuetify = createVuetify({
// //   icons: {
// //     defaultSet: 'mdi', // This is already the default value - only for display purposes
// //   },
// //   components,
// //   directives,
// // })
//
// const app = createApp(App)
// app.component('VueDatePicker', VueDatePicker)
//
// const pinia = createPinia()
// pinia.use(piniaPluginPersistedstate)
// pinia.use(resetStore)
//
// app.use(pinia)
// app.use(vuetify)
// app.use(router)
// app.use(LoadScript)
//
// // Sentry.init({
// //   app,
// //   dsn: 'https://14d3ec259130449692f017bb3c8c3126@glitch.zxklmb.xyz/2',
// //   integrations: [
// //     Sentry.browserTracingIntegration({ router }),
// //     Sentry.metrics.metricsAggregatorIntegration(),
// //   ],
// // });
//
// app.mount('#app')
